import { render, staticRenderFns } from "./ImplementationsSidebar.vue?vue&type=template&id=0447a8a4"
import script from "./ImplementationsSidebar.vue?vue&type=script&lang=js"
export * from "./ImplementationsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ImplementationsSidebar.vue?vue&type=style&index=0&id=0447a8a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports